<template>
  <b-container v-if="this.$root.signedIn">
    <br>
    <b-row v-show="!this.loading" align-h="center">
      <b-col cols=8>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion1 variant="primary">
              Search Criteria
              <font-awesome-icon icon="caret-down" size="lg" v-if="!showCriteria"/> 
              <font-awesome-icon icon="caret-up" size="lg" v-if="showCriteria"/>
            </b-btn>
          </b-card-header>
          <b-collapse id="accordion1" visible accordion="accordion1" role="tabpanel" v-model="showCriteria">
            <b-card-body>
              <b-container>
                <b-row>
                  <b-col>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Element</b-col>
                      <b-col>
                        <multiselect v-model="element" :options="elementList" :placeholder="'Select Element'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Programme(s)</b-col>
                      <b-col>
                        <multiselect v-model="programmes" :options="programmeList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'Do not report on Programme'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Industry(s)</b-col>
                      <b-col>
                        <multiselect v-model="industries" :options="industryList" :multiple="true" :close-on-select="false" :placeholder="'Do not report on Industry'" :select-label="''" :deselect-label="''"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Year(s)</b-col>
                      <b-col>
                        <multiselect v-model="years" :options="yearList" :multiple="true" :close-on-select="false" :placeholder="'Do not report on Year'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Customer(s)</b-col>
                      <b-col>
                        <multiselect v-model="customers" :options="customerList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'Do not report on Customer'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Country(s)</b-col>
                      <b-col>
                        <multiselect v-model="countries" :options="countryList" :multiple="true" :close-on-select="false" :placeholder="'Do not report on Country'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Region(s)</b-col>
                      <b-col>
                        <multiselect v-model="regions" :options="regionList" :multiple="true" :close-on-select="false" :placeholder="'Do not report on Region'" group-values="regions" group-label="country" :group-select="true"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col>
                        <b-btn variant="primary" @click="calculateData()" :disabled="!element || element.length == 0">Show</b-btn>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="pb-5 pt-5 text-center" align-h="center">
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin v-show="loadingData"/>
        <element-industry-bar v-if="chartData" :chart-data="chartData" :element-name="element" :width="1000" :height="600"/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// @ is an alias to /src
import {industries, countries, regions} from '@/services/constants';
import * as _ from 'lodash';
import * as API from '@/services/API';
import * as Reporting from '@/services/Reporting';
import ElementIndustryBar from '@/graphs/ElementIndustryBar';

export default {
  name: "IndustryElements",
  components: {
    ElementIndustryBar
  },
  computed: {
    
  },
  watch: {
    countries: function(val) {
      this.regionList = this.getRegions(val);
    },
    programmes: function(val) {
      // all
      if (this.programmes.length === 1 && this.programmes[0].id === -1) return;

      // otherwise filter.
      this.elementList = this.getElements(val);
      this.element = this.elementList.indexOf(this.element) > -1 ? this.element : null;
      this.elementList.sort();
    },
    element: function(val) {
      this.programmeList = this.getProgrammes(val);
      this.programmes = this.programmes.filter(programme => (this.programmes.length === 1 && this.programmes[0].id === -1) || this.programmeList.indexOf(programme) > -1);
      this.programmeList.unshift({id: -1, name: 'All'});
    }
  },
  created () {
    this.init();
  },
  data: function() {
    return {
      customerList: [],
      industryList: [],
      programmeList: [],
      elementList: [],
      countryList: [],
      regionList: [],
      allElements: [],
      customers: [],
      industries: [],
      element: null,
      programmes: [],
      allProgrammes: [],
      countries: [],
      regions: [],
      chartData: null,
      showCriteria: true,
      loading: true,
      loadingData: false,
      years: [],
      yearList: []
    }
  },
  methods: {
    init() {
      this.regionList = this.getRegions(null);
      this.industryList = JSON.parse(JSON.stringify(industries));
      this.industryList.unshift('All');
      this.countryList = JSON.parse(JSON.stringify(countries));
      this.countryList.unshift('All');

      const thisYear = new Date().getFullYear();
      this.years = [];
      const startYear = 2009;
      for (let i = 0; i < thisYear - startYear; i++) {
        this.yearList.push(thisYear - i);
      }
      this.yearList.unshift('All');

      this.loading = true;
      return Promise.all([
        API.getCustomers().then(results => {
          this.customerList = results.results;
          this.customerList.unshift({id: -1, name: 'All'});
        }),
        API.getProgrammes().then(results => {
          this.programmeList = _.clone(results.results);
          this.allProgrammes = results.results;
          this.programmeList.unshift({id: -1, name: 'All'});
        }),
        Reporting.getElementNames().then(results => {
          this.allElements = results;
        })
      ]).then(() => {
        this.elementList = _.uniq(_.clone(this.allElements).map(element => element.local_name));
        this.elementList.sort();
        this.loading = false; 
      });
    },
    getRegions(countries) {
      return Object.keys(regions).map((country) => {
        const result =  {
          country,
          regions: JSON.parse(JSON.stringify(regions[country]))
        };
        result.regions.unshift('All');
        return result;
      }).filter(x => (!countries || countries === 'All' || countries.length === 0 || countries.indexOf(x.country) != -1))
    },
    getElements(programmes) {
      if (!programmes || programmes.length == 0 || programmes[0] === -1) return _.uniq(this.allElements.map(element => element.local_name));
      const programmeIds = programmes.map(programme => programme.id);
      return _.uniq(this.allElements.filter(element => programmeIds.indexOf(element.programme_id) > -1).map(element => element.local_name));
    },
    getProgrammes(element) {
      if (!element) return this.allProgrammes;
      const programmeIds = this.allElements.filter(anElement => element === anElement.local_name).map(anElement => anElement.programme_id);
      return this.allProgrammes.filter(programme => programmeIds.indexOf(programme.id) > -1);
    },
    calculateData() {
      this.loadingData = true;
      this.showCriteria = false;

      // make queries
      const query = {};
      const groupBy = [];
      if (this.customers && this.customers.length > 0) {
        query['survey_run.customer_id'] = this.customers.map(customer => customer.id).filter(x => x > 0);
        groupBy.push('customer.name');  
        if (query['survey_run.customer_id'].length === 0) delete query['survey_run.customer_id'];  
      } 
      if (this.regions && this.regions.length > 0) {
        query['customer.region'] = this.regions.filter(x => x != 'All');
        groupBy.push('customer.region');
        if (query['customer.region'].length === 0) delete query['customer.region'];
      } 
      if (this.programmes && this.programmes.length > 0) {
        query['survey_run.programme_id'] = this.programmes.map(programme => programme.id).filter(x => x > 0);
        groupBy.push('programme.name');
        if (query['survey_run.programme_id'].length === 0) delete query['survey_run.programme_id'];
      }
      if (this.countries && this.countries.length > 0) {
        query['customer.country'] = this.countries.filter(x => x != 'All');
        groupBy.push('customer.country');
        if (query['customer.country'].length === 0) delete query['customer.country'];
      } 
      if (this.industries && this.industries.length > 0) {
        query['customer.industry'] = this.industries.filter(x => x != 'All');
        groupBy.push('customer.industry');
        if (query['customer.industry'].length === 0) delete query['customer.industry'];
      }
      if (this.years && this.years.length > 0) {
        query['survey_run.year'] = this.years.filter(x => x != 'All');
        groupBy.push('survey_run.year');
        if (query['survey_run.year'].length === 0) delete query['survey_run.year'];
      }

      // get
      return Reporting.getElementScores(this.element, {where: query, groupBy}).then(dataPoints => {
        // we want 8 bars - but there must be at least 10 responses per bar.
        const other = {
          averageScore: 0,
          cumulativeScore: 0,
          responses: 0,
          dimension: 'Others'
        };
        let runningTotal = 0;
        dataPoints.sort((a, b) => b.responses - a.responses);
        const nextSet = dataPoints.reduce((accumulator, dataPoint, index) => {
          runningTotal += dataPoint.responses;
          if (dataPoint.responses < 10 || index > 9) {
            other.cumulativeScore += dataPoint.averageScore * dataPoint.responses;
            other.responses += dataPoint.responses;
            other.averageScore = (other.cumulativeScore / other.responses).toFixed(2);
          } else {
            const fields = Object.keys(dataPoint);
            fields.sort();
            dataPoint.dimension = fields.reduce((accumulator1, field) => {
              if (field.indexOf('.') > 0) accumulator1.push(dataPoint[field]);
              return accumulator1;
            }, []).join(', ');
            accumulator.push(dataPoint);
          }
          return accumulator;
        }, []);
        nextSet.sort((a, b) => {
          if(/^[0-9]+$/.test(`${a.dimension}`) && /^[0-9]+$/.test(`${b.dimension}`)) {
            return parseInt(a.dimension) - parseInt(b.dimension);
          } 
          return a.dimension > b.dimension ? -1 : 1;
        });
        if (other.responses > 0) {
          nextSet.push(other);
        }
        this.chartData = nextSet;
        this.loadingData = false;
        
      });
    }
  }
}
</script>
<style>
.vue-js-switch#gears-or-scores {
  font-size: 16px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/IndustryElements.vue